import type { Theme, Components } from "@mui/material/styles";
import { CloseIcon } from "./CustomIcons";

// ----------------------------------------------------------------------

export default function Chip(theme: Theme): Components<Theme> {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },
      styleOverrides: {
        colorDefault: {
          "&.MuiChip-sizeMedium > .MuiChip-avatar, .MuiChip-avatarSmall": {
            color: theme.palette.text.secondary,
          },
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          "&.MuiChip-colorPrimary": {
            borderColor: theme.palette.primary.main,
          },
          "&.MuiChip-colorSecondary": {
            borderColor: theme.palette.secondary.main,
          },
        },
        root: {
          "&.MuiChip-colorInfo .MuiChip-avatar": {
            color: theme.palette.info.contrastText,
            backgroundColor: theme.palette.info.dark,
          },
          "&.MuiChip-colorSuccess .MuiChip-avatar": {
            color: theme.palette.success.contrastText,
            backgroundColor: theme.palette.success.dark,
          },
          "&.MuiChip-colorWarning .MuiChip-avatar": {
            color: theme.palette.warning.contrastText,
            backgroundColor: theme.palette.warning.dark,
          },
          "&.MuiChip-colorError .MuiChip-avatar": {
            color: theme.palette.error.contrastText,
            backgroundColor: theme.palette.error.dark,
          },
        },
      },
    },
  };
}
